<template>
  <div class="about-fields">
    <div
      v-for="(info, index) in visibleFields(memberData)"
      :key="`${info.value}-${index}`"
      :class="`about-fields-data ${info.key}`"
    >
      <span
        v-if="expanded"
        class="info-title"
      >
        {{ info.title }}
      </span>
      <span class="info-value">{{ info.value ? info.value : '-' }}</span>
    </div>
  </div>
</template>
<script>
import { filter, cloneDeep, map, find } from 'lodash-es';
import { formatDate } from '~/utils/time_utils';
import dayjs from 'dayjs';
import { mapState } from 'vuex';
import {
  EMPLOYMENT_TYPE_OPTIONS,
  WORKPLACE_MODEL_OPTIONS,
  EMPLOYED_THROUGH_OPTIONS,
  TERMINATION_REASON_OPTIONS,
} from '~/app_constants';

export default {
  name: 'MemberProfileData',
  props: {
    columnType: {
      type: String,
      default: 'info',
    },
    // Map of enabled fields, have show_ prefix {show_field_key: true/false}
    profileFields: {
      type: Object,
      required: true,
    },
    memberData: {
      type: Object,
      required: true,
    },
    customVisibleByDefault: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    showingAll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tooltipOptions: Object.freeze({ placement: 'left', html: true }),
    };
  },
  computed: {
    ...mapState(['organization']),
    nameMaps() {
      return EMPLOYMENT_TYPE_OPTIONS.concat(
        WORKPLACE_MODEL_OPTIONS,
        EMPLOYED_THROUGH_OPTIONS,
        TERMINATION_REASON_OPTIONS,
      );
    },
  },
  methods: {
    visibleFields(member) {
      let fields;

      if (this.columnType === 'info') {
        fields = cloneDeep(member.info_fields);
      } else {
        fields = cloneDeep(member.employment_fields);

        map(fields, (field) => {
          const match = find(this.nameMaps, { id: field.value });

          if (match) {
            field.value = match.text;
          }
        });
      }

      map(fields, (field) => {
        field.value = field.type === 'date' ? formatDate(dayjs(field.value)) : field.value;
      });

      if (this.showingAll) {
        return fields;
      }

      return filter(fields, (field) => field.value && this.isEnabled(field));
    },
    isEnabled(field) {
      const enabled = this.profileFields[`show_${field.key}`];

      return field.key.startsWith('custom_') ? enabled ?? this.customVisibleByDefault : enabled;
    },
  },
};
</script>
